export const GATEWAY_URL = process.env.REACT_APP_GATEWAY_URL;

export async function validateToken() {

    var res = await apiFetch("auth/validate");
    return res.ok;
}


export async function apiFetch(url, options = {}) {
    let idempotencyKey = null;

    if (options.idempotencyAction) {
        idempotencyKey = getIdempotencyKey(options.idempotencyAction);
    }

    const headers = {
        ...options.headers,
        'Accept': 'application/json, text/plain',
        'Content-Type': 'application/json;charset=UTF-8',
        ...(idempotencyKey ? { "Idempotency-Key": idempotencyKey } : {}),
    };

    // IMPORTANT: pass signal through
    const config = {
        ...options,
        credentials: "include",
        headers,
    };

    let response = await fetch(`${GATEWAY_URL}/${url}`, config);

    if (response.status === 401) {
        const refreshRes = await fetch(GATEWAY_URL + "/auth/refresh", {
            method: "POST",
            credentials: "include",
            headers: { "Content-Type": "application/json" }
        });

        if (refreshRes.ok) {
            return await fetch(`${GATEWAY_URL}/${url}`, config);
        }

        return Promise.reject("Unauthorized");
    }

    return response;
}

const PREFIX = "idem:";
const TTL_MS = 5 * 60 * 1000; // 5 minutes

export function getIdempotencyKey(action) {
    const keyName = `${PREFIX}${action}`;

    const stored = sessionStorage.getItem(keyName);
    if (stored) {
        const { key, ts } = JSON.parse(stored);
        if (Date.now() - ts < TTL_MS) {
            return key;
        }
    }

    const key = crypto.randomUUID();
    sessionStorage.setItem(
        keyName,
        JSON.stringify({ key, ts: Date.now() })
    );

    return key;
}

export function clearIdempotencyKey(action) {
    sessionStorage.removeItem(`${PREFIX}${action}`);
}
